/* Responsibility: Setup LMS result page for desktop */
import simplehub from 'simplehub';
import setupAttachedCalendar from '../../calendar/setupAttachedCalendar.js';
import setupDropdown from '../../filters/modules/sortingDropdown.js';
import setupUrlState from '../../filters/urlState.js';
import constants from '../../lib/constants.js';
import dom from '../../lib/dom.js';
import { setup } from './lmsResultPage.js';

const T = FINN.travel;
const P = FINN.travel.pp;

const eventHub = simplehub.create();

const resultViewCriteria = {};

T.pp.setupPage = function () {
    setupUrlState({
        eventHub,
        browserWindow: window,
        history: window.History,
    });
    setup(eventHub, resultViewCriteria, setupAttachedCalendar);

    setupDropdown.forPale({
        key: constants.SORT_CRITERIA,
        urlKey: 'sorter',
        root: dom.byId('sortDropDownDesktop'),
        eventHub,
        resultViewCriteria,
        dropdownKeys: P.initialResult.sortDropdownKeys,
        urlQueryParams: T.urlQueryParams,
    });
};

if (module.hot) {
    module.hot.accept();
    if (module.hot.status() !== 'idle') {
        FINN.travel.pp.setupPage();
    }
}
